import styled from 'styled-components';
import { mediaQuery } from '../../../../common/styles/styleUtil';

export const BurgerMenuWrapper = styled.div`
  margin-left: 16px;
  display: none;
  @media (${mediaQuery.tablet}) {
    display: flex;
    align-items: center;
  }
`;

export const MobileNavigationWrapper = styled.div`
  margin-top: 48px;
  border-top: solid 1px #e9ebed;
`;

export const MobileNavigationItemWrapper = styled.div`
  border-bottom: solid 1px #e9ebed;
`;

export const NavigationDropdown = styled.div`
  display: grid;
  row-gap: 16px;
  padding-bottom: 16px;
`;
